import React, { useState, useEffect } from "react";
import Temp_imgs from '../utils/Temp_imgs'
import { Button, Modal, Row, Col } from 'react-bootstrap';
// import { useMappedState, useDispatch } from 'redux-react-hook';

export default function ProjAddCustTempImgs(props) {
    // const [tmpImg, setTmpImg] = useState(tmp);

    // function onClickStep(index) {
    //     console.log("[onClickStep]", index);
    //     if (props.pid) {
    //         props.history.push('/proj/edit/' + props.pid + '/' + (index));
    //     } else {
    //         alert("請先完成目前步驟");
    //     }
    // }

    function render() {
        let { data, show, onSwitch, tmpImg } = props;
        let tmp = [];
        let current = tmpImg ? tmpImg : data.icon;
        console.log(data.icon, tmpImg);
        for (let i = 0; i < 23; i++) {
            let url1 = "https://cdn-staging.dataa.com.tw/uploads/EZC_images/customerProjects/template_" + (i * 2 + 1) + ".jpg";
            let url2 = "https://cdn-staging.dataa.com.tw/uploads/EZC_images/customerProjects/template_" + (i * 2 + 2) + ".jpg";
            // console.log(i, url1, url2);
            tmp.push(
                <Row className="mb-2" key={i}>
                    <Col><img className={current == url1 ? "selected w-100" : "w-100"} onClick={() => { props.onSelect(url1) }} src={Temp_imgs[i * 2]} /></Col>
                    <Col><img className={current == url2 ? "selected w-100" : "w-100"} onClick={() => { props.onSelect(url2) }} src={Temp_imgs[i * 2 + 1]} /></Col>
                </Row>
            );
        }
        // let url1 = "https://cdn-staging.dataa.com.tw/uploads/EZC_images/customerProjects/template_45.jpg";
        // tmp.push(<Row className="mb-2" key={22}>
        //     <Col><img className={data && data.icon == url1 ? "selected w-100" : "w-100"} onClick={() => { props.onSelect(url1) }} src={Temp_imgs[44]} /></Col>
        // </Row>);

        return (
            <Modal
                dialogClassName="ezc-modal"
                show={show}
                onHide={onSwitch}
                backdrop="static"
                keyboard={false}
                centered
                aria-labelledby="contained-modal-title-vcenter"
            >
                <Modal.Header>
                    <Modal.Title>請選擇出現在調查主頁面的圖片：</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {tmp}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={props.onSwitch}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={props.onConfirmImg}>插入</Button>
                </Modal.Footer>
            </Modal>
        )
    }
    return render();
}